import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a49b2eb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Instructions", -1))

import { 
        InstructionsComposable,
        LandingPagesComposable
    } from '@/interfaces'
    import useInstructions from '@/composables/useInstructions'
    import useLandingPages from '@/composables/useLandingPages'
    import GenericButton from '@/elements/GenericButton.vue'
    import CurrentInstruction from '@/articles/CurrentInstruction.vue'
    
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const {
        step,
        loadNext,
        loadPrevious
    }: InstructionsComposable = useInstructions()

    const {
        goHome,
        playGame
    }: LandingPagesComposable = useLandingPages()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createVNode(CurrentInstruction, { step: _unref(step) }, null, 8, ["step"]),
    _createElementVNode("aside", null, [
      (_unref(step) === 1)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 0,
            text: "Back Home",
            onClick: _unref(goHome)
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_unref(step) !== 1)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 1,
            text: "Previous Step",
            onClick: _unref(loadPrevious)
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_unref(step) !== 4)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 2,
            text: "Next Step",
            onClick: _unref(loadNext)
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (_unref(step) === 4)
        ? (_openBlock(), _createBlock(GenericButton, {
            key: 3,
            text: "Play Game",
            onClick: _unref(playGame)
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})